import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import theme from "./theme/Theme";
import { ConfigProvider } from "antd";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ConfigProvider
        theme={{
          token: {
            // colorPrimary: theme.data.voyager.antd.colors.colorPrimary,
            // colorTextBase: theme.data.voyager.antd.colors.colorTextBase,
            // colorLink: theme.data.voyager.antd.colors.colorLink
          },
        }}
      >
        <App />
      </ConfigProvider>
    </BrowserRouter>
  </React.StrictMode>
);
